function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10.6667,
  r: 10,
  fill: "#5F37FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.99992 4C8.68138 4 7.39245 4.39099 6.29612 5.12354C5.19979 5.85608 4.34531 6.89727 3.84072 8.11544C3.33614 9.33362 3.20412 10.6741 3.46135 11.9673C3.71859 13.2605 4.35353 14.4484 5.28588 15.3807C6.21823 16.3131 7.40611 16.948 8.69932 17.2052C9.99253 17.4625 11.333 17.3304 12.5511 16.8259C13.7693 16.3213 14.8105 15.4668 15.5431 14.3705C16.2756 13.2741 16.6666 11.9852 16.6666 10.6667C16.6666 9.79119 16.4942 8.92428 16.1591 8.11544C15.8241 7.30661 15.333 6.57168 14.714 5.95262C14.0949 5.33356 13.36 4.8425 12.5511 4.50747C11.7423 4.17244 10.8754 4 9.99992 4Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.6666 10.28L12.0666 11.0867H12.0533C12.1817 11.1594 12.2823 11.2728 12.3394 11.4089C12.3965 11.545 12.4068 11.6963 12.3686 11.8389C12.3305 11.9815 12.2461 12.1074 12.1287 12.1969C12.0113 12.2864 11.8675 12.3344 11.7199 12.3333C11.6031 12.3341 11.4882 12.3042 11.3866 12.2467L9.65325 11.2467L9.59325 11.1867L9.48658 11.1C9.46052 11.067 9.43816 11.0312 9.41992 10.9933C9.39819 10.9575 9.38031 10.9195 9.36659 10.88C9.34845 10.8376 9.3372 10.7926 9.33325 10.7467V10.6667V7.33332C9.33325 7.15651 9.40349 6.98694 9.52851 6.86192C9.65354 6.73689 9.82311 6.66666 9.99992 6.66666C10.1767 6.66666 10.3463 6.73689 10.4713 6.86192C10.5963 6.98694 10.6666 7.15651 10.6666 7.33332V10.28Z",
  fill: "#5F37FF"
});

var SvgEventsPageMobileNav = function SvgEventsPageMobileNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEventsPageMobileNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EventsPageMobileNav.9cfce942.svg";
export { ForwardRef as ReactComponent };